export class EmployeeList {
  public empNo: any;
  public Empno_legacy: any;
  public empName: any;
  public emailID: any;
  public role: any;
  public businessUnit: any;
  public empStatus: any;
  public showProject: boolean;
  public showEmployee: boolean;
  public employees = [];
  public projects = [];
  constructor(data: any) {
    this.empNo = data.Empno ? data.Empno : "";
    this.Empno_legacy = data.Empno_legacy ? data.Empno_legacy : "";
    this.empName = data.Empname ? data.Empname : "";
    this.emailID = data.EmailID ? data.EmailID : "";
    this.role = data.Role ? data.Role : "";
    this.businessUnit = data.businessUnit ? data.businessUnit : "";
    this.empStatus = data.Employment_Status ? data.Employment_Status : "";
    this.showProject = data.showProject ? data.showProject : false;
    this.showEmployee = data.showEmployee ? data.showEmployee : false;
    this.employees = data.employee ? data.employee : [];
    this.projects = data.projects ? data.projects : [];
  }
}

export class EmployeeProject {
  public projectId: any;
  public projectName: any;
  public totalHrs: any;
  public activities = [];
  public showActivity: boolean;
  constructor(data: any) {
    this.projectId = data.projectID ? data.projectID : "";
    this.projectName = data.projectname ? data.projectname : "";
    if (!!data.totalHrs) {
      const totalHrsconvertValue = this.convertHoursToMins(data.totalHrs);
      this.totalHrs = this.convertMinsToHrsMins(totalHrsconvertValue);
    }
    this.activities = data.activity_hrs ? data.activity_hrs : [];
    this.activities.forEach((element) => {
      const totalHrsconvertValue = this.convertHoursToMins(element.FilledHrs);
      element.FilledHrs = this.convertMinsToHrsMins(totalHrsconvertValue);
    });
    this.showActivity = data.showActivity ? data.showActivity : false;
  }

  convertHoursToMins(hrs) {
    const a = hrs.toString().split(":");
    let minutes = 0;
    if (a[1]) {
      minutes = +a[0] * 60 + +a[1];
    } else {
      minutes = +Number(a[0]) * 60;
    }
    return minutes;
  }

  convertMinsToHrsMins(mins) {
    const h: any = Math.floor(mins / 60);
    let m: any = mins % 60;
    m = Math.round(m);
    const hrs = h < 10 ? "0" + h : h;
    const mns = m < 10 ? "0" + m : m;
    return `${hrs}:${mns}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/rm/organizational-report/organizational-report.ts